import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  display: grid;
  place-items: center;
  height: 100vh;
  width: 100vw;
`;
